import { useEffect } from "react";

// Lightweight per-route SEO: updates title + description + canonical + OG tags.
export function useSEO({ title, description, path = "" }) {
  useEffect(() => {
    if (title) document.title = title;
    const set = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = sel.replace("meta[", "").replace("]", "").split("=");
        el.setAttribute(k, v.replace(/["']/g, ""));
        document.head.appendChild(el);
      }
      el.setAttribute(attr, val);
    };
    if (description) {
      set('meta[name="description"]', "content", description);
      set('meta[property="og:description"]', "content", description);
    }
    if (title) {
      set('meta[property="og:title"]', "content", title);
      set('meta[name="twitter:title"]', "content", title);
    }
    const canonicalHref = `https://indril.in${path}`;
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalHref);
    set('meta[property="og:url"]', "content", canonicalHref);
  }, [title, description, path]);
}
